import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-x-1" }
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode(" Veuillez sélectionner l'embarquement de destination "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_4 = { class: "flex flex-col w-full my-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, "Liste des passagers concernés", -1)
const _hoisted_6 = {
  key: 0,
  class: "mt-2 space-y-2"
}
const _hoisted_7 = { class: "flex items-center justify-center flex-shrink-0 w-12 h-12 font-bold text-white rounded-full bg-secondary" }
const _hoisted_8 = { class: "ml-4" }
const _hoisted_9 = { class: "text-lg font-semibold text-white" }
const _hoisted_10 = { class: "text-sm text-gray-400" }
const _hoisted_11 = {
  key: 1,
  class: "mt-2 text-gray-500"
}
const _hoisted_12 = { class: "flex flex-row items-end justify-end w-full space-x-4" }


export default /*#__PURE__*/_defineComponent({
  __name: 'PassengerTransferModal',
  props: {
    open: { type: Boolean },
    name: {},
    isLoading: { type: Boolean },
    selectedRows: {},
    embarkations: {}
  },
  emits: ["close", "mounted", "select-destination", "submit"],
  setup(__props: any) {

	/**
	 * Bulk passenger transfer modal — extracted from NewPassenger.vue.
	 *
	 * Receives the list of selected passengers + the list of destination
	 * embarkations; emits the chosen destination uuid back to the parent which
	 * owns the API call.
	 */
	
	

return (_ctx: any,_cache: any) => {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_ModalPage = _resolveComponent("ModalPage")!

  return (_ctx.open)
    ? (_openBlock(), _createBlock(_component_ModalPage, {
        key: 0,
        title: 'Transfert des passagers',
        name: _ctx.name,
        styleContent: "w-full",
        styleFooter: "w-full",
        styleModal: '!w-2/6',
        onClose: _cache[3] || (_cache[3] = (e) => _ctx.$emit('close', e)),
        onMounted: _cache[4] || (_cache[4] = (e) => _ctx.$emit('mounted', e))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_SelectTag, {
                placeholder: "Embarquement de destination",
                onModel: _cache[0] || (_cache[0] = (e) => _ctx.$emit('select-destination', e.uuid)),
                data: JSON.stringify(_ctx.embarkations ?? [])
              }, null, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              (_ctx.selectedRows.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRows, (passenger, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flex items-center p-4 border rounded-lg bg-primary border-secondary"
                      }, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(index + 1), 1),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", _hoisted_9, _toDisplayString(passenger.first_name), 1),
                          _createElementVNode("p", _hoisted_10, "Identifiant : " + _toDisplayString(passenger.identity_no), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, "Aucun passager disponible."))
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ButtonTag, {
              label: "Annuler",
              activeIcon: false,
              icon: "/media/icons/add-icon.svg",
              css: "bg-gray-500 border-secondary text-white px-6 py-2 hover:bg-gray-600 w-full active:bg-gray-500 focus:outline-none",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close', _ctx.name)))
            }),
            _createVNode(_component_ButtonTag, {
              label: "Transférer",
              activeIcon: false,
              loader: _ctx.isLoading,
              "text-loading": 'Transfert en cours...',
              css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152] focus:outline-none",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('submit')))
            }, null, 8, ["loader"])
          ])
        ]),
        _: 1
      }, 8, ["name"]))
    : _createCommentVNode("", true)
}
}

})